import { useFollowUpGrid, useFollowUpTable } from "../hooks/useFollowUp";
import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography,
} from "@mui/material";
import DataGrid from "components/DataGrid";
import FilterFollowUp from "./FilterFollowUp";
import { FormProvider } from "react-hook-form";
import "../css/index.css";
import { BtnCancel, BtnClose, BtnConfirm, BtnExportExcel } from "components/Button/ButtonAll";
import TableContent from "./Dialog/TableContent";

const FollowUp = () => {
	const { form, dataRow, onGetData, onClear, handleExportExcel, open, handleClose, handleOpen, selectYear, startYear, setSelectYear, setStartYear, loadingComplete, loadingPlan, onGetPlanYear, dataActivity, lstFileMOU, lstFilePlan, setLstFileMOU, setLstFilePlan } =
		useFollowUpTable(true);
	const { dataColumnApprover } = useFollowUpGrid();

	return (
		<FormProvider {...form}>
			<Dialog
				onClose={handleClose}
				open={open}
				id="dialog_assign_unit"
				sx={{
					".MuiDialog-container .MuiPaper-root": {
						maxWidth: "none",
					},
					zIndex: 1500
				}}
			>
				<DialogTitle
					id="request-dialog-title"
					sx={{ display: "flex", alignItems: "center", justifyContent: loadingComplete ? "center" : "flex-start" }}
				>
					<Typography
						sx={{ color: "rgb(52, 71, 103)", fontWeight: 700 }}
					>
						{loadingComplete ? "การติดตามผลการดำเนินงานของกองทุนจัดการซากดึกดำบรรพ์" : "แสดงแผน/ผลประจำปี"} {selectYear}
					</Typography>
				</DialogTitle>

				{loadingPlan ? (
					<DialogContent
						sx={{
							minWidth: "600px",
							userSelect: "none",
							height: "172px",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div className="loading">
							<span></span>
							<span></span>
							<span></span>
							<span></span>
							<span></span>
						</div>
					</DialogContent>
				) : (<TableContent loadingComplete={loadingComplete} dataActivity={dataActivity} lstFileMOU={lstFileMOU} setLstFileMOU={setLstFileMOU} lstFilePlan={lstFilePlan} setLstFilePlan={setLstFilePlan} selectYear={selectYear} startYear={startYear} setSelectYear={setSelectYear} setStartYear={setStartYear} />)
				}

				<DialogActions sx={{ justifyContent: "center" }}>
					{
						loadingComplete ? (
							<>
								<BtnExportExcel
									txt="Export to Excel File"
									onClick={() => handleExportExcel(selectYear - 543)}
									bgcolor="#107c11"
									bgcolorHover="#107c11"
									id="export-excel"
								/>
								<BtnClose
									sSize="medium"
									id="close-btn"
									onClick={handleClose}
								/>
							</>

						) : (
							<>
								<BtnCancel
									id="cancel-btn"
									onClick={handleClose}
								/>
								<BtnConfirm
									id="confirm-btn"
									onClick={() => onGetPlanYear()}
								/>
							</>
						)
					}

					<Box sx={{ width: "10px" }}></Box>
				</DialogActions>
				<Box sx={{ width: "10px", height: "1rem" }}></Box>
			</Dialog>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<FilterFollowUp
						onSearch={() => onGetData(dataRow)}
						onClear={() => onClear()}
						onPreview={() => handleOpen(true)}
					/>
				</Grid>
				<Grid item xs={12}>
					<DataGrid
						sTableID="tableFollowUp"
						columns={dataColumnApprover}
						rows={dataRow}
						modeFilter={0}
						isLoading={false}
						onLoadData={(e) => onGetData(e)}
						isShowCheckBox={false}
						onDelete={() => { }}
						isHiddenToolHead
					/>
				</Grid>
			</Grid>
		</FormProvider>
	);
};

export default FollowUp;
